var _excluded = ["theme", "children"];

function cov_2ijo9jc43y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx";
  var hash = "e0f11dd79de78a00992d40df0e558e5d1ca3a90b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 5
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 25,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 5
          },
          end: {
            line: 17,
            column: 6
          }
        },
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 25,
            column: 5
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 45
          },
          end: {
            line: 20,
            column: 50
          }
        }, {
          start: {
            line: 20,
            column: 53
          },
          end: {
            line: 20,
            column: 57
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e0f11dd79de78a00992d40df0e558e5d1ca3a90b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ijo9jc43y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2ijo9jc43y();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ThemeProvider } from '@chakra-ui/system';
import Spritesheet from '../core/Icon/Spritesheet';
import { eero } from '../theme';
import { FontFace, Reset } from '../styles'; // This uses an SVG spritesheet which must be injected once per page.
// The approach is detailed [here](https://css-tricks.com/svg-sprites-use-better-icon-fonts/)
// Some of the pros and cons of this approach are detailed [here](https://opendoor.slack.com/archives/C023V2C14BX/p1628281932070100)

cov_2ijo9jc43y().s[0]++;
export var Themed = function Themed(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_2ijo9jc43y().f[0]++;
  cov_2ijo9jc43y().s[1]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spritesheet, null), /*#__PURE__*/React.createElement(ThemeProvider, _extends({}, props, {
    theme: theme ? (cov_2ijo9jc43y().b[0][0]++, theme) : (cov_2ijo9jc43y().b[0][1]++, eero)
  }), /*#__PURE__*/React.createElement(FontFace, null), /*#__PURE__*/React.createElement(Reset, null), children));
};